import { StanModal } from '@/components';
import { SUBSCRIPTION_TIERS } from '@/lib/api/subscriptions';
import { PlanIntervalSelector } from './PlanIntervalSelector';
import { PlanDetailCard } from './PlanDetailCard';
import { ChangePlanConfirmationModal } from './ChangePlanConfirmationModal';
import { useChangePlanModal } from '../../hooks/useChangePlanModal';

interface ChangePlanModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const ChangePlanModal = ({ isOpen, onClose }: ChangePlanModalProps) => {
    const {
        newTier,
        newInterval,
        setNewTier,
        setNewInterval,
        hasPlanBeenEdited,
        isCurrentPlan,
        buttonText,
        isLoading,
        estimate,
        showConfirmationModal,
        handleConfirm,
        handleConfirmationConfirm,
        handleConfirmationGoBack,
        handleConfirmationClose,
        subscriptionIsCancelled,
    } = useChangePlanModal(isOpen, onClose);

    return (
        <>
            <StanModal
                id='change-plan-modal'
                isOpen={isOpen && !showConfirmationModal}
                onClose={onClose}
                title='Select Plan'
                size='lg'
                primaryActionLabel={buttonText}
                primaryActionDisabled={!hasPlanBeenEdited && !subscriptionIsCancelled}
                primaryActionLoading={isLoading}
                onPrimaryAction={handleConfirm}
                className='!max-w-[min(720px,calc(100vw-2rem))] pt-4'
            >
                <div className='flex w-full flex-col gap-6'>
                    {/* Interval Selector */}
                    <PlanIntervalSelector interval={newInterval} onToggleInterval={setNewInterval} />

                    {/* Plan Cards */}
                    <div className='bg-brand-subtle flex w-full flex-col rounded-2xl md:flex-row'>
                        <PlanDetailCard
                            tier={SUBSCRIPTION_TIERS.CREATOR}
                            interval={newInterval}
                            selected={newTier === SUBSCRIPTION_TIERS.CREATOR}
                            isCurrentPlan={isCurrentPlan(SUBSCRIPTION_TIERS.CREATOR)}
                            onCardClick={() => setNewTier(SUBSCRIPTION_TIERS.CREATOR)}
                        />
                        <PlanDetailCard
                            tier={SUBSCRIPTION_TIERS.CREATOR_PRO}
                            interval={newInterval}
                            selected={newTier === SUBSCRIPTION_TIERS.CREATOR_PRO}
                            isCurrentPlan={isCurrentPlan(SUBSCRIPTION_TIERS.CREATOR_PRO)}
                            onCardClick={() => setNewTier(SUBSCRIPTION_TIERS.CREATOR_PRO)}
                        />
                    </div>
                </div>
            </StanModal>

            <ChangePlanConfirmationModal
                isOpen={showConfirmationModal}
                onClose={handleConfirmationClose}
                onConfirm={handleConfirmationConfirm}
                onGoBack={handleConfirmationGoBack}
                tier={newTier}
                interval={newInterval}
                estimate={estimate}
                isUpdating={isLoading}
            />
        </>
    );
};
